module.exports = __webpack_public_path__ + "media/images/holidaybox/bg-md-cd5943c50c7dd2d9f89632800417e5d5.jpg";